function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { j as o } from "./index.es33.js";
import { useState as n } from "react";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import "./index.es97.js";
import "./index.es98.js";
import "./index.es99.js";
import "./index.es100.js";
import "./index.es101.js";
import "./index.es102.js";
import "./index.es103.js";
import "./index.es104.js";
import { palette as l } from "./index.es36.js";
import { Icon as t } from "./index.es7.js";
import { PositionVariants as f } from "./index.es172.js";
import { Tooltip as s } from "./index.es13.js";
import "nanoid";
import "./index.es15.js";
import m from "./index.es493.js";

var b = function b() {
  return o.jsx("span", {
    className: m.preloadTickIcon,
    children: o.jsx(t, {
      size: 16,
      color: l.gray1,
      icon: t.icons.system.s.utilities.tick
    })
  });
},
    R = function R(_ref) {
  var i = _ref.value,
      c = _ref.withCopy,
      a = _ref.isDisabled;

  var _n = n(!1),
      _n2 = _slicedToArray(_n, 2),
      y = _n2[0],
      e = _n2[1],
      _n3 = n(!1),
      _n4 = _slicedToArray(_n3, 2),
      u = _n4[0],
      r = _n4[1],
      p = !i || i.length === 0,
      x = function x() {
    e(!0), r(!0), navigator.clipboard.writeText(i);
  },
      d = function d() {
    r(!1), setTimeout(function () {
      e(!1);
    }, 300);
  };

  return !a || !c ? null : o.jsxs(o.Fragment, {
    children: [o.jsx(b, {}), o.jsx(s, {
      isVisibleDisabled: p,
      isAlwaysVisible: u,
      position: f.underCenter,
      title: y ? s.CopyText.success : s.CopyText.copy,
      children: o.jsx("button", {
        disabled: p,
        onMouseLeave: d,
        type: "button",
        className: m.copyBtn,
        onClick: x,
        children: o.jsx(t, {
          size: 16,
          color: l.gray6,
          icon: t.icons.system.s.utilities.clone
        })
      })
    })]
  });
};

export { R as CopyText };